import {create} from "jss";
import rtl from "jss-rtl";
import {jssPreset, StylesProvider} from "@mui/styles";

// Configure JSS
const jss = create({
    plugins: [...jssPreset().plugins, rtl()],
});

const DirectionProvider = (props: ChildrenPropType) => {
    return <StylesProvider jss={jss}>{props.children}</StylesProvider>;
};

export default DirectionProvider;
